import { categoriesTermsApi, useCategoryTerms } from "api/categories-terms";
import { PaziaTermsList } from "components/organisms";
import { CourseTermsFormValues } from "components/templates/AddTermsModal/CreateTermsForm";
import { UpdateTermsFormValues } from "components/templates/AddTermsModal/UpdateTermsForm";
import { PaziaInlineLoader } from "components/atoms";
import { QUERIES_KEYS } from "queries";
import React from "react";
import { useInavalidate, useToaster } from "utils";

export const CategoryTerms = ({ categoryId }: { categoryId: number }) => {
  const invaldiateTerms = useInavalidate(QUERIES_KEYS.CATEGORY_TERMS(categoryId));
  const { showSuccess, showError } = useToaster();
  const { terms, isLoading: loadingTerms } = useCategoryTerms(categoryId);

  const onTermDelete = async (termId: number) => {
    try {
      await categoriesTermsApi.deleteResource(categoryId, termId);
      showSuccess("Regulamin został usunięty.");
    } catch (e) {
      showError("Nie udało się usunąć regulaminu.");
    } finally {
      invaldiateTerms();
    }
  };

  const onCreateSubmit = async (values: CourseTermsFormValues) => {
    try {
      await categoriesTermsApi.create(categoryId, values);
      showSuccess("Regulamin został dodany");
      invaldiateTerms();
    } catch (e) {
      console.error(e);
      showError("Wystąpił błąd podczas dodawania regulaminu");
    }
  };
  const onUpdateSubmit = async (values: UpdateTermsFormValues) => {
    try {
      await categoriesTermsApi.update(categoryId, values.id, values);
      showSuccess("Regulamin został zaktualizowany");
      invaldiateTerms();
    } catch (e) {
      console.error(e);
      showError("Wystąpił błąd podczas aktualizowania regulaminu");
    }
  };

  if (loadingTerms)
    return (
      <>
        <div className="flex w-full justify-center">
          <PaziaInlineLoader />
        </div>
      </>
    );
  return (
    <>
      <PaziaTermsList
        terms={terms}
        onCreateSubmit={onCreateSubmit}
        onUpdateSubmit={onUpdateSubmit}
        onTermDelete={onTermDelete}
      />
    </>
  );
};
